
export default function IconOfflineEvents() {
  return (
    <svg
      enableBackground="new 0 0 512 512"
      height="40"
      viewBox="0 0 512 512"
      width="40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <circle cx="256" cy="50" r="50"></circle>
        <path d="m310.534 108.457c-14.301 13.35-33.474 21.543-54.534 21.543s-40.233-8.193-54.534-21.543c-21.201 11.048-36.495 31.919-39.793 56.543h188.654c-3.299-24.624-18.592-45.495-39.793-56.543z"></path>
        <circle cx="76" cy="367" r="50"></circle>
        <circle cx="436" cy="367" r="50"></circle>
        <path d="m129.81 426.147c-14.22 12.948-33.109 20.853-53.81 20.853s-39.59-7.905-53.81-20.853c-12.814 9.053-21.19 23.97-21.19 40.853v30c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-30c0-16.883-8.376-31.8-21.19-40.853z"></path>
        <path d="m489.81 426.147c-14.22 12.948-33.109 20.853-53.81 20.853s-39.59-7.905-53.81-20.853c-12.814 9.053-21.19 23.97-21.19 40.853v30c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-30c0-16.883-8.376-31.8-21.19-40.853z"></path>
        <path d="m309.81 426.147c-14.22 12.948-33.109 20.853-53.81 20.853s-39.59-7.905-53.81-20.853c-12.814 9.053-21.19 23.97-21.19 40.853v30c0 8.284 6.716 15 15 15h120c8.284 0 15-6.716 15-15v-30c0-16.883-8.376-31.8-21.19-40.853z"></path>
        <path d="m356 367c0-35.382 23.098-65.454 55-75.978v-66.022h5c8.284 0 15-6.716 15-15s-6.716-15-15-15h-15v-60c0-3.978-1.58-7.793-4.394-10.606l-20-20c-5.857-5.858-15.355-5.858-21.213 0s-5.858 15.355 0 21.213l15.607 15.606v53.787h-275c-8.284 0-15 6.716-15 15s6.716 15 15 15h5v66.022c31.902 10.524 55 40.596 55 75.978 0 12.612-2.944 24.545-8.164 35.166 7.083 5.122 13.191 11.303 18.164 18.246 4.973-6.943 11.082-13.123 18.164-18.246-5.22-10.621-8.164-22.554-8.164-35.166 0-44.112 35.888-80 80-80s80 35.888 80 80c0 12.612-2.944 24.545-8.164 35.166 7.083 5.122 13.191 11.303 18.164 18.246 4.973-6.943 11.082-13.123 18.164-18.246-5.22-10.621-8.164-22.554-8.164-35.166z"></path>
        <circle cx="256" cy="367" r="50"></circle>
      </g>
    </svg>
  );
}
